import React from 'react';
import {UserTotalPanel} from "../UserTotalPanel";
import {riskTypeIdentifiers} from "../../../routes";
import {RiskRowBox} from "./RiskRowBox";
import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import {getPanelLink, usersFromQuery} from "../DashboardPanels/panelCommon";
import {
    getSharedMailboxesWithLogin
} from "../../../services/shared/SharedMailboxesWithLogin";

export interface SharedMailboxWithLoginProps {
  numberInCircle: number;
}
export const SharedMailboxesWithLoginCount = (props: SharedMailboxWithLoginProps) => {
  const {numberInCircle} = props;

  const fullQuery = useQueryWithAccessToken({
      queryKey: [cacheKeys.sharedMailboxes],
      queryFunction: getSharedMailboxesWithLogin,
      queryFunctionVariables:{}
    }
  )

  // If there's a SoT then run the query, if not supply placeholder values to the UI
  const {isLoading, count, users, isError} = usersFromQuery(fullQuery)


  return (<RiskRowBox>
    <UserTotalPanel
      count={count}
      users={users}
      riskName="Shared Mailboxes with Login"
      riskDescription={<span><em>Shared mailboxes which still have login enabled.</em></span>}
      viewAllUrl={getPanelLink(riskTypeIdentifiers.sharedMailboxes, count)}
      numberInCircle={numberInCircle}
      largeMode={false}
      isLoading={isLoading}
      isError={isError}
    />
  </RiskRowBox>)
};
